import React, { Component } from 'react'
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty';
import SlackWebHook from "../services/slack";
import validation from "../services/validation"
import mailer from "../services/mail"
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import { post } from "../services/fetch"
import { success, error } from './Toast';

class AKContactForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            mobile: "",
            location: "",
            description: "",
            validator: false,
            disabled: false,
            countryId: 0,
            countryList: []
        },
        this.adarshModal = null
    }

    componentDidMount() {
        if(window.bootstrap) {
            this.adarshModal = new bootstrap.Modal(document.getElementById('AdarshModal'), {});
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEmpty(this.props.locationDetails) && (this.props.locationDetails !== prevProps.locationDetails)) {
            this.setState({
                location: `${this.props.locationDetails.city}`
            });
        }
        if (this.props.countryData !== prevProps.countryData) {
            let ipdata, geoString;
            geoString = JSON.parse(localStorage.getItem('user_location_details_local'));
            if(geoString) {
                ipdata = geoString.geoLocationDetails;
            }
            if(!ipdata) {
                ipdata = {
                    country_code: '',
                }
            }
            const countryMatch = find(this.props.countryData, ['code', ipdata.country_code]);
            const cntryId = countryMatch ? countryMatch.countryId : 0;
            this.setState({
                countryList: this.props.countryData,
                countryId: cntryId
            });
        }
    }

    onChange = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        state.validator = false;
        this.setState(state);
    }

    reset = () => {
        this.setState({
            ...this.state,
            name: "",
            email: "",
            mobile: "",
            location: `${this.props.locationDetails.city}`,
            description: "",
            disabled: false,
            validator: false
        })
    }

    onSubmit = () => {
        const parentThis = this;
        const state = parentThis.state;
        state.name = state.name.trim();
        state.location = state.location.trim();
        if( validation.text(state.name)
            && validation.email(state.email)
            && validation.mobile(state.mobile)
            && validation.text(state.location)
        ){
            state.disabled = true;
            parentThis.setState(state);
            let mobile = state.mobile !== ''? `${filter(state.countryList, ['countryId', parseInt(state.countryId)]).length > 0 ? filter(state.countryList, ['countryId', parseInt(state.countryId)])[0].dialCode : '+91'} ${state.mobile}`:'';
            let input = {
                name: state.name,
                email: state.email,
                mobile: mobile,
                location: `${state.location}, ${filter(state.countryList, ['countryId', parseInt(state.countryId)])[0].name}`,
                description: `Request from ${state.name}, URL:${process.env.NEXT_PUBLIC_APP_URI}${this.props.router.asPath}`,
                templateUrl: process.env.NEXT_PUBLIC_APP_URI + this.props.router.asPath,
                contactType: 'adarsh_khandelwal'
            };
            post(`${process.env.NEXT_PUBLIC_API_URI}${process.env.NEXT_PUBLIC_API_VERSION}/contactUs?_format=json`, input, {}).then((res) => {
                if(res.code === "201" && res.status === "success") {
                    let data = {
                        fullName: state.name
                    }
                    mailer.sendMail(input.email, "contactUs-mail", [], [], "You have sent a request.", false, data).then((res) => {
                        if(res.status === 'success' && res.code === '250'){
                            console.log("mail-sent");
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                    try{
                        SlackWebHook.sendSlackMessage(`New contact request from ${input.name} (${input.email} - ${input.mobile}) from ${input.location}`, 'Landing pg ak', ':computer', `${process.env.NEXT_PUBLIC_ENV === 'production'?'adarsh-landing-pg-leads':process.env.NEXT_PUBLIC_SLACK_CHANNEL}`);
                    }
                    catch (e) {
                        console.log(e);
                    }
                    let adminData = {
                        fullName: state.name,
                        mail: state.email,
                        phone: mobile,
                        location: `${state.location}, ${filter(state.countryList, ['countryId', parseInt(state.countryId)])[0].name}`,
                        message: `Request from ${state.name}, URL:${process.env.NEXT_PUBLIC_APP_URI}${this.props.router.asPath}`,
                    }
                    mailer.sendMail(process.env.NEXT_PUBLIC_ADMIN_EMAIL, "contactUsAdmin-mail", [], [], "New Contact Request", false, adminData).then((res) => {
                        if(res.status === 'success' && res.code === '250'){
                            console.log("mail-sent-admin");
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                    state.name = "";
                    state.email = "";
                    state.mobile = "";
                    state.location = `${state.location}`;
                    state.description = "";
                    state.disabled = false;
                    parentThis.setState(state);
                    this.adarshModal.hide();
                    this.props.router.push(`/thank-you?name=${input.name}&location=${input.location}&type=${this.props.type}`);
                    success('Thank you for contacting with us.');
                }else{
                    state.disabled = false;
                    parentThis.setState(state);
                    error('Something Went Wrong');
                }
            }).catch(() => {
                state.disabled = false;
                parentThis.setState(state);
                error('Something Went Wrong');
            });
        }
        else{
            state.validator = true;
            parentThis.setState(state);
        }
    }

    render() {
        const { formId, router } = this.props;
        const { name, email, mobile, validator, location, disabled, countryId, countryList } = this.state;
        return (
            <div className="ak-form" id={formId}>
                <input type="hidden" id="template-url" name="template-url" value={process.env.NEXT_PUBLIC_APP_URI+router.asPath}/>
                <div className="form-group mb-4 mb-md-4">
                    {formId !== 'adarsh-contact-page' && <label htmlFor="name">Name:</label> }
                    <input
                        type="text"
                        className={`form-control ${validator && (validation.text(name) ? "is-valid" : "is-invalid")}`}
                        value={name}
                        onChange={this.onChange.bind(this)}
                        name="name" id="name" autoComplete="given-name" placeholder="Type your name" />
                </div>
                <div className="form-group mb-4 mb-md-4">
                    {formId !== 'adarsh-contact-page' && <label htmlFor="email">Email ID:</label> }
                    <input
                        type="email"
                        className={`form-control ${validator && (validation.email(email) ? "is-valid" : "is-invalid")}`}
                        value={email}
                        onChange={this.onChange.bind(this)}
                        name="email" id="email" autoComplete="email" placeholder="Type your email " />
                </div>
                <div className={`form-group mb-4 mb-md-4 `}>
                    {formId !== 'adarsh-contact-page' && <label htmlFor="country">Select Country</label>}
                    <select id="country"
                        className={`form-select ${(validator && (validation.positiveNumber(countryId) ? 'is-valid' : 'error')).toString()}`}
                        name="countryId" value={countryId} onChange={this.onChange.bind(this)}>
                        <option value="0" disabled>Select Country</option>
                        {countryId != null && countryList.length > 0 && countryList.map((country, index) =>
                            <option
                                value={country.countryId}
                                defaultValue={country.countryId == countryId ? true : false }
                                key={index}>
                                {country.name}
                            </option>
                        )}
                    </select>
                </div>
                {formId !== 'adarsh-contact-page' && <label htmlFor="phone">Phone No:</label> }
                <div className="input-group mb-4 mb-md-4">
                    <span className="input-group-text">
                        {filter(countryList, ['countryId', parseInt(countryId)]).length > 0 ? filter(countryList, ['countryId', parseInt(countryId)])[0].dialCode : '+91'}
                    </span>
                    <input
                        type="text"
                        className={`form-control ${validator && (validation.mobile(mobile) ? "is-valid" : "is-invalid")}`}
                        value={mobile}
                        onChange={this.onChange.bind(this)}
                        name="mobile" id="phone" autoComplete="tel-local" placeholder="Type your phone No" />
                </div>
                <div className="form-group mb-4 mb-md-4">
                    {formId !== 'adarsh-contact-page' &&<label htmlFor="city">City:</label> }
                    <input
                        type="text"
                        className={`form-control ${validator && (validation.text(location) ? "is-valid" : "is-invalid")}`}
                        value={location}
                        onChange={this.onChange.bind(this)}
                        name="location" id="city" autoComplete="address-level2" placeholder="Enter your City" />
                </div>
                <div className="d-flex justify-content-center">
                    <button type="submit" className='btn btn-warning bg-white btn-with-icon btn-text-revert' disabled={disabled} onClick={this.onSubmit}>
                        {this.state.disabled ? 'Sending...' : 'Book now'}
                        <span className="btn-icon md bg-yellow">{!this.state.disabled ? <MdArrowForward /> : <div>...</div>}</span>
                    </button>
                </div>
            </div>
        )
    }
}

AKContactForm.propTypes = {
    formId: PropTypes.string,
    type: PropTypes.string,
    router: PropTypes.object,
    locationDetails: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    countryData: PropTypes.array,
}

AKContactForm.defaultProps = {
    formId: 'adarsh-contact-page',
    type: 'static'
}

export default AKContactForm;
